import React, { useState, useEffect } from 'react';
import T from 'prop-types';
// icons
import { ReactComponent as CloseIcon } from 'icons/close.svg';
// styles
import classnames from 'classnames/bind';
import styles from './DismissBanner.module.scss';

const cx = classnames.bind(styles);

const DismissBanner = ({ onStateChange, contentRenderer, className }) => {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    onStateChange?.(open);
  }, [open]);

  const handleCloseClick = () => setOpen(false);

  return (
    <div className={cx('wrapper', className, { closed: !open })}>
      {contentRenderer?.()}
      <CloseIcon className={cx('close-icon')} onClick={handleCloseClick} />
    </div>
  );
};

DismissBanner.propTypes = {
  onStateChange: T.func,
  contentRenderer: T.func.isRequired,
  className: T.oneOfType([T.func, T.string]),
};

export default DismissBanner;
